import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ApiService } from "app/shared/services/api.service";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import swal from "sweetalert2";

@Component({
  selector: "app-add-update-classbybatch",
  templateUrl: "./add-update-classbybatch.component.html",
  styleUrls: ["./add-update-classbybatch.component.scss"],
})
export class AddUpdateClassbybatchComponent implements OnInit {
  classForm: FormGroup;
  referenceForm: FormGroup;
  reference_id: any
  reference_model = {
    refId: '',
    name: '',
    links: '',
    description: '',
    IP: '',
    notes: '',
    admin_notes: ''
  }
  class_model = {
    instructor: "",
    title: "",
    date: "",
    start_time: "",
    end_time: "",
    notes: "",
    type: "",
    status: "",
    admin_notes: "",
    students: [],
    project_tag: "",
    references: [],
  };
  classByStudentForm: FormGroup;
  instructor_list: any = [];
  course_list: any = [];
  student_list: any = [];
  enrollment_list: any = [];
  topic_list: any = [];
  session_list: any = [];
  select_student: any = [];
  select_enrollment: any = [];
  select_topic = null;
  select_session = null;
  select_course = null;
  ipAddress: any
  referenceList = [];
  selectedRef: string[] = [];
  status_list = [
    { id: "upcoming", name: "Upcoming" },
    { id: "today", name: "Today" },
    { id: "past", name: "Past" },
  ];
  isStudentSubmit: boolean = false;
  class_id: any;
  students_array = [];
  student_obj = {
    batch_id: "",
    student_id: "",
    enrollment_id: "",
    course_id: "",
    session_id: "",
    topic_id: [],
  };
  batch_list: any = [];
  select_batch = null;
  data_array: any = [];
  radio_button: any = null;
  project_tags_list = [];
  project_tags_tagcat_id = '685971ad7bf67c03258f6740';
  selected_channel: any;
  constructor(
    private formBuilder: FormBuilder,
    public toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    public apiService: ApiService,
    private route: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.class_id = params["id"];
      if (this.class_id) {
        this.classGetById(this.class_id);
        this.getBatchByClass(this.class_id);
        this.getProjectTags()
      }
    });
  }

  ngOnInit(): void {
    this.class_model.date = moment(new Date()).format("YYYY-MM-DD");
    this.class_model.instructor = null;
    this.class_model.status = null;
    this.class_model.start_time = "11:00";
    this.class_model.end_time = "13:00";

    this.classByStudentForm = this.formBuilder.group({
      title: ["", Validators.required],
      date: ["", Validators.required],
      start_time: ["", Validators.required],
      end_time: ["", Validators.required],
      notes: [""],
      admin_notes: [""],
      references: ['',],
    });
    this.referenceForm = this.formBuilder.group({
      name: ['',],
      links: ['',],
      description: ['',],
      IP: ['',],
      notes: ['',],
      admin_notes: ['',]
    })
    this.getAllInstructorList();
    this.getAllBatch();
    this.getCourseList();
    this.getProjectTags()
  }
  ngAfterViewInit() {
    this.class_model.date = moment(new Date()).format("YYYY-MM-DD");
  }
  classGetById(id) {
    this.apiService.getClassById(id).subscribe((res: any) => {
      this.class_model = res?.data[0];
      let date: any = moment(res?.data[0]?.date).format("YYYY-MM-DD");
      this.class_model.date = date;
      this.class_model.title = res?.data[0]?.title;
      this.class_model.start_time = res?.data[0]?.start_time;
      this.class_model.end_time = res?.data[0]?.end_time;
      this.class_model.notes = res?.data[0]?.notes;
      this.class_model.admin_notes = res?.data[0]?.admin_notes;
      this.class_model.status = res?.data[0]?.status;
      this.class_model.instructor = res?.data[0]?.instructor?._id;
      this.class_model.students = res?.data[0]?.students;
      if (this.class_model?.references?.length > 0) {
        this.referenceList = this.class_model?.references?.map((item) => item)
        this.selectedRef = this.referenceList?.map((item) => item?._id)
        // this.jobModel.references=this.selectedRef
      }
    });
  }
  getAllInstructorList() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.instructor_list = res?.items;
    });
  }
  getInstructorId(event) {
    this.class_model.instructor;
  }
  getStatusId(event) {
    this.class_model.status;
  }
  getCourseList() {
    this.apiService.getCourseList(1, 1000).subscribe((res: any) => {
      this.course_list = res?.data?.items;
    });
  }
  getChangeChannelId(event) {
    this.class_model.project_tag = this.selected_channel
  }
  getProjectTags() {
    console.log('Loading project tags - filtering for LIVE and DESK only');

    this.apiService.getTagByTagCatgoryId(this.project_tags_tagcat_id).subscribe(
      (res: any) => {
        console.log('Project tags API response:', res);

        if (res?.error) {
          console.error('Error in project tags response:', res.error);
          this.project_tags_list = [];
          return;
        }

        const allTags = res?.data || res || [];
        console.log('Total tags received:', allTags.length);
        console.log('All tag names:', allTags.map((t: any) => ({ name: t?.name, displayname: t?.displayname, _id: t?._id })));

        // Filter to show only LIVE and DESK tags (check both name and displayname, case-insensitive)
        this.project_tags_list = allTags.filter((tag: any) => {
          const name = (tag?.name || '').toUpperCase().trim();
          const displayname = (tag?.displayname || '').toUpperCase().trim();
          return name === 'LIVE' || name === 'DESK' || displayname === 'LIVE' || displayname === 'DESK';
        });

        console.log('Project tags filtered:', this.project_tags_list.length, 'items (LIVE/DESK only)');

        if (this.project_tags_list.length === 0) {
          console.warn('No LIVE or DESK tags found. Available tags:', allTags.map((t: any) => t?.name || t?.displayname));
        }
      },
      (error) => {
        console.error('Error loading project tags:', error);
        this.project_tags_list = [];
      }
    );
  }
  getRefId(event) {
    if (!this.class_id) {
      this.selectedRef
      this.class_model.references = event
    }
    if (this.class_id) {
      this.class_model.references = event
      let data = this.class_model.references.filter(obj => !('_id' in obj));
      if (data) {
        this.class_model.references = data
        const newValues = event.filter(value => !this.class_model.references.some(obj => obj._id === value._id))
        this.class_model.references.push(...newValues)
      }
    }
  }
  getCourseId(event) {
    this.select_course;
    this.getTopicList(this.select_course);
    this.getSessionsList(this.select_course);
  }
  getSessionsList(id) {
    this.apiService.getSessionsByCourseId(id).subscribe((res: any) => {
      this.session_list = res?.data;
    });
  }
  getSessionId(event) {
    this.select_session;
    let topic = this.select_session.topic_id.map((item) => item._id);
    this.select_topic = topic;
  }
  getStudentId(event) {
    this.student_obj.student_id = event.name;
    this.select_student;
    this.select_enrollment = this.select_student.map((item) => item._id);
  }
  getEnrollmentByStudent(id) {
    if (id) {
      this.apiService.getEnrolmentByUserId(id).subscribe((res: any) => {
        this.enrollment_list = res?.data?.map((item) => item);
        this.select_enrollment = this.enrollment_list[0]._id;
        this.select_course = this.enrollment_list[0].course_id;
        if (this.select_course) {
          this.getTopicList(this.select_course);
        }
      });
    }
  }
  getEnrollmentId(event) {
    this.select_enrollment;
  }
  getTopicId(event) {
    this.select_topic;
    if (!this.class_id) {
      let topic = event.map((item) => item.name);
      this.student_obj.topic_id = [topic];
    }
  }
  getTopicList(id) {
    this.apiService.getTopicsByCourseId(id).subscribe((res: any) => {
      if (res.statusCode === 200) {
        const extractedData = res?.data.map((item) => {
          return item.data.flatMap((subArray) => {
            return subArray.flatMap((innerArray) => {
              return innerArray.map((obj) => {
                return {
                  name: obj.name,
                  _id: obj._id,
                };
              });
            });
          });
        });
        this.topic_list = extractedData.flat();
      }
    });
  }
  back() {
    this.route.navigate(["/classes/list"]);
  }
  addBatchPopup(content) {
    const modalOptions: NgbModalOptions = {
      size: "lg",
    };
    const modalRef = this.modalService.open(content, modalOptions);
    modalRef.result.then(
      (result) => {
        // console.log(`Modal closed with result: ${result}`);
      },
      (reason) => { }
    );
  }
  editStudentPopup(content, data) {
    this.select_batch = data?.students[0]?.batch_id;
    if (this.select_batch) {
      this.getAllEnrollmentByBatch(this.select_batch, this.class_model.instructor);
    }
    this.select_student = data?.students.map((item) => item.student_id[0]._id);
    this.select_course = data?.students[0]?.course_id[0]._id;
    if (this.select_course) this.getTopicList(this.select_course);

    if (data?.students[0].session_id) {
      this.select_session = data?.students[0].session_id.map(
        (item) => item._id
      );
    }
    this.select_topic = data?.students[0].topic_id.map((item) => item._id);

    const modalOptions: NgbModalOptions = {
      size: "lg",
    };
    const modalRef = this.modalService.open(content, modalOptions);
    modalRef.result.then(
      (result) => {
        this.select_student = null;
        this.select_enrollment = null;
        this.select_session = null;
        this.select_topic = null;
        this.select_course = null;
      },
      (reason) => {
        this.select_student = null;
        this.select_enrollment = null;
        this.select_session = null;
        this.select_topic = null;
        this.select_course = null;
      }
    );
  }
  addStudent() {
    for (let i = 0; i < this.select_student.length; i++) {
      // Determine the session ID
      let session = this.select_session ? this.select_session._id : "";

      // Create the student object
      let obj = {
        batch_id: this.select_batch,
        student_id: this.select_student[i].user_id._id,
        enrolment_id: this.select_enrollment[i],
        topic_id: this.select_topic,
        course_id: this.select_course,
        ...(session && { session_id: session }),
      };

      // Add the student object to the class_model's students array
      this.class_model.students.push(obj);
    }

    // Update student_obj with the names of selected students
    this.student_obj.student_id = this.select_student.map(
      (item) => item.user_id.name
    );

    // Add the updated student_obj to students_array
    this.students_array.push({ ...this.student_obj });

    // Mark the submission as complete
    this.isStudentSubmit = true;

    // Resetting values
    this.select_student = [];
    this.select_enrollment = [];
    this.select_topic = null;
    this.select_session = null;
    this.select_course = null;
    this.isStudentSubmit = true;
    this.modalService.dismissAll()
  }
  submit() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    if (!this.class_id) {
      let model = {
        instructor: this.class_model.instructor,
        title: this.classByStudentForm.value.title,
        date: moment(this.class_model.date).format("YYYY-MM-DD"),
        start_time: this.classByStudentForm.value.start_time,
        end_time: this.classByStudentForm.value.end_time,
        notes: this.classByStudentForm.value.notes,
        type: "batch",
        status: this.class_model.status,
        admin_notes: this.classByStudentForm.value.admin_notes,
        students: this.class_model.students,
        project_tag: this.class_model.project_tag,
        references: this.class_model.references,
      };

      this.apiService.createClass(model).subscribe((res: any) => {
        if (res?.isSuccess) {
          this.spinner.hide();
          this.toastr.success("Class created successfully");
          this.route.navigate(["/classes/list"]);
        } else {
          this.spinner.hide();
          this.toastr.error(res?.error);
        }
      });
    }

    if (this.class_id) {
      this.apiService
        .updateClass(this.class_id, this.class_model)
        .subscribe((res: any) => {
          if (res?.isSuccess) {
            this.spinner.hide();
            this.toastr.success("Class update successfully");
            this.route.navigate(["/classes/list"]);
          } else {
            this.spinner.hide();
            this.toastr.error(res?.error);
          }
        });
    }
  }

  openModal(content) {
    this.reference_model.IP = this.ipAddress
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  submitRef() {

    this.referenceForm = this.formBuilder.group(this.reference_model);
    this.referenceList.push(this.referenceForm.value)
    this.referenceList = this.referenceList.map(item => item)
    this.referenceForm.reset(this.reference_model);
    this.modalService.dismissAll()
  }

  editItem(data, content) {
    this.reference_id = data._id
    this.reference_model.refId = this.reference_id
    this.reference_model.name = data.name
    this.reference_model.links = data.links
    this.reference_model.description = data.description
    this.reference_model.notes = data.notes
    this.reference_model.admin_notes = data.admin_notes
    this.reference_model.IP = data.IP
    this.class_id = data.class_id
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  deleteStudent(index) {
    this.class_model.students.splice(index, 1);
    this.students_array.splice(index, 1);
  }
  getAllBatch() {
    this.apiService.getBatchList(1, 100).subscribe((res: any) => {
      this.batch_list = res?.data?.items;
    });
  }
  getBatchId(event) {
    this.select_batch;
    this.student_obj.batch_id = event.name;
    this.getAllEnrollmentByBatch(this.select_batch, this.class_model.instructor);
  }
  getAllEnrollmentByBatch(id, instructor) {
    this.apiService.getEnrolmentsByBatchId(id, instructor).subscribe((res: any) => {
      this.enrollment_list = res?.data;
      this.student_list = res?.data;
      this.select_student = this.enrollment_list.map((item) => item);
      this.select_enrollment = this.enrollment_list.map((item) => item._id);
      this.select_course = this.enrollment_list[0].course_id._id;
      if (this.select_course) {
        this.getTopicList(this.select_course);
        this.getSessionsList(this.select_course);
      }
    });
  }
  getBatchByClass(id) {
    this.apiService.getBatchStudentByClassId(id).subscribe((res: any) => {
      this.data_array = res?.data?.flatMap((item) => item.batches);
    });
  }
  updateTopics() {
    let body = {
      students: [
        {
          topic_id: this.select_topic,
          session_id: this.select_session,
        },
      ],
    };
    this.apiService
      .updateTopicsInClass(this.class_id, this.select_batch, body)
      .subscribe((res: any) => {
        if (res?.isSuccess) {
          this.modalService.dismissAll();
          this.toastr.success("Class update successfully");
          this.getBatchByClass(this.class_id);
        } else this.toastr.error(res?.error);
      });
  }
  studentDelete(data) {
    let student_id = data;
    swal
      .fire({
        title: "Are you sure?",
        text: "You won't be able to delete this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#2F8BE6",
        cancelButtonColor: "#F55252",
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-warning",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,
      })
      .then((result) => {
        if (result.value) {
          this.apiService
            .deleteStudentFromClass(this.class_id, student_id)
            .subscribe((res: any) => {
              if (res?.isSuccess) {
                swal.fire({
                  icon: "success",
                  title: "Deleted",
                  text: "student deleted successfully.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                this.modalService.dismissAll();
                this.getBatchByClass(this.class_id);
              } else {
                swal.fire({
                  icon: "error",
                  title: "Error",
                  text: `${res.error}`,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
              }
            });
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Your file is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  isClassIdSet(): boolean {
    return this.class_id;
  }
  getRadioValue(event) {
    this.radio_button = event.target.value;
  }
}
